module.exports = __webpack_public_path__ + "static/fonts/NanumSquareNeoTTF-eHv.b50f260.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NanumSquareNeoTTF-eHv.woff2
// module id = Mitq
// module chunks = 0